import styled from 'styled-components';

const DropdownContainer = styled.div`
  position: relative;
  text-transform: uppercase;
`;

const DropdownInputContainer = styled.div`
  height: 36px;
  border: 1px solid ${props => props.theme.secondaryColor};
  border-radius: 4px;
  background: #F8F9FB;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;

  &.changed {
    border: 1px solid ${props => props.theme.primaryColor};
  }
`;

const DropdownText = styled.span`
  color: ${props => props.theme.bodyColor};
  font: 700 14px/120% ${props => props.theme.fontFamilyBody};
`;

const OptionsContainer = styled.div`
  border: 1px solid #D7DFE7;
  border-radius: 4px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  position: absolute;
  margin-top: 6px;
  right: 0;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding: 15px 10px;
  z-index: 2;
`;

const Option = styled.div`
  padding: 5px 8px 0 8px;
  height: 40px;
  font: 800 16px/30px ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
  cursor: pointer;

  &.selected {
    color: ${props => props.theme.bodyColor};
  }

  &:hover {
    border-radius: 4px;
    background: #F8F9FB
  }
`;

const Icon = styled.span`
  color: ${props => props.theme.secondaryColor};
  font-size: 24px !important;
`;

export {
  DropdownContainer,
  DropdownInputContainer,
  DropdownText,
  Icon,
  OptionsContainer,
  Option,
};
